// src/pages/mantenimiento/config/maintenanceConfig.tsx
import { ReactElement } from 'react';
import {
  Business as BusinessIcon,
  HealthAndSafety as HealthAndSafetyIcon,
  Category as CategoryIcon,
  LocalHospital as LocalHospitalIcon,
  ReceiptLong as ReceiptLongIcon,
  Store as StoreIcon,
  WcOutlined as WcOutlinedIcon,
  AssignmentReturn as AssignmentReturnIcon,
  SwapHoriz as SwapHorizIcon,
  AccountBox as AccountBoxIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  Group as GroupIcon,
  Description as DescriptionIcon,
  Inventory as InventoryIcon,
  Payment as PaymentIcon
} from '@mui/icons-material';

export type ModuleCategory = 'recursos_humanos' | 'ventas_compras' | 'catalogos' | 'sistema';

interface ModuleConfig {
  title: string;
  description: string;
  icon: ReactElement;
  path: string;
  entityPath: string;
  category: ModuleCategory;
}

export const MODULE_CONFIGS: Record<string, ModuleConfig> = {
  'afp': {
    title: 'AFP',
    description: 'Administradoras de Fondos de Pensiones',
    icon: <BusinessIcon />,
    path: 'afp',
    entityPath: 'afp',
    category: 'recursos_humanos'
  },
  'arl': {
    title: 'ARL',
    description: 'Administradoras de Riesgos Laborales',
    icon: <HealthAndSafetyIcon />,
    path: 'arl',
    entityPath: 'arl',
    category: 'recursos_humanos'
  },
  'eps': {
    title: 'EPS',
    description: 'Entidades Promotoras de Salud',
    icon: <LocalHospitalIcon />,
    path: 'eps',
    entityPath: 'eps',
    category: 'recursos_humanos'
  },
  'generos': {
    title: 'Géneros',
    description: 'Gestión de Tipos de Género',
    icon: <WcOutlinedIcon />,
    path: 'generos',
    entityPath: 'generos',
    category: 'recursos_humanos'
  },
  'estados-compra': {
    title: 'Estados de Compra',
    description: 'Estados de Procesos de Compra',
    icon: <ReceiptLongIcon />,
    path: 'estados-compra',
    entityPath: 'estados-compra',
    category: 'ventas_compras'
  },
  'estados-venta': {
    title: 'Estados de Venta',
    description: 'Estados de Procesos de Venta',
    icon: <StoreIcon />,
    path: 'estados-venta',
    entityPath: 'estados-venta',
    category: 'ventas_compras'
  },
  'motivo-devolucion-compra': {
    title: 'Motivos Dev. Compra',
    description: 'Motivos de Devolución de Compras',
    icon: <AssignmentReturnIcon />,
    path: 'motivo-devolucion-compra',
    entityPath: 'motivo-devolucion-compra',
    category: 'ventas_compras'
  },
  'motivo-devolucion-venta': {
    title: 'Motivos Dev. Venta',
    description: 'Motivos de Devolución de Ventas',
    icon: <SwapHorizIcon />,
    path: 'motivo-devolucion-venta',
    entityPath: 'motivo-devolucion-venta',
    category: 'ventas_compras'
  },
  'tipos-pago': {
    title: 'Tipos de Pago',
    description: 'Gestión de Tipos de Pago',
    icon: <PaymentIcon />,
    path: 'tipos-pago',
    entityPath: 'tipos-pago',
    category: 'ventas_compras'
  },
  'categorias': {
    title: 'Categorías',
    description: 'Gestión de Categorías de Productos',
    icon: <CategoryIcon />,
    path: 'categorias',
    entityPath: 'categorias',
    category: 'catalogos'
  },
  'tipos-cliente': {
    title: 'Tipos de Cliente',
    description: 'Gestión de Tipos de Cliente',
    icon: <GroupIcon />,
    path: 'tipos-cliente',
    entityPath: 'tipos-cliente',
    category: 'catalogos'
  },
  'tipos-documento': {
    title: 'Tipos de Documento',
    description: 'Gestión de Tipos de Documento',
    icon: <DescriptionIcon />,
    path: 'tipos-documento',
    entityPath: 'tipos-documento',
    category: 'catalogos'
  },
  'tipos-embalaje': {
    title: 'Tipos de Embalaje',
    description: 'Gestión de Tipos de Embalaje',
    icon: <InventoryIcon />,
    path: 'tipos-embalaje',
    entityPath: 'tipos-embalaje',
    category: 'catalogos'
  },
  'perfiles': {
    title: 'Perfiles',
    description: 'Gestión de Perfiles de Usuario',
    icon: <AccountBoxIcon />,
    path: 'perfiles',
    entityPath: 'perfiles',
    category: 'sistema'
  },
  'roles': {
    title: 'Roles',
    description: 'Gestión de Roles de Usuario',
    icon: <AdminPanelSettingsIcon />,
    path: 'roles',
    entityPath: 'roles',
    category: 'sistema'
  }
} as const;

export type ModuleConfigKey = keyof typeof MODULE_CONFIGS;

export const CATEGORY_LABELS: Record<ModuleCategory, string> = {
  recursos_humanos: 'Recursos Humanos',
  ventas_compras: 'Ventas y Compras',
  catalogos: 'Catálogos',
  sistema: 'Sistema'
};

export const CATEGORY_COLORS: Record<ModuleCategory, string> = {
  recursos_humanos: '#3498db',
  ventas_compras: '#e74c3c',
  catalogos: '#f39c12',
  sistema: '#9b59b6'
};